/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Attack_HelpInputs */

const en_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How quickly ducking is applied (ms) when VO starts`)
};

const fr_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitesse d'application de l'atténuation (ms) au début de la VO`)
};

const de_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie schnell die Ducking-Funktion angewendet wird (ms), wenn VO startet`)
};

const it_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con quale rapidità viene applicato il ducking (ms) quando inizia il VO`)
};

const ru_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как быстро применяется приглушение (мс) в момент начала VO`)
};

const es_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué tan rápido se aplica el agachamiento (ms) cuando comienza la VO`)
};

const zh_cn2_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO开始时，闪避动作应用的速度（毫秒）`)
};

const ja_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO 開始時にダッキングが適用される速さ (ms)`)
};

const hi_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO शुरू होने पर झुकने की क्रिया कितनी जल्दी (मिलीसेकंड में) लागू होती है`)
};

const pt_pt2_audio_description_export_automix_attack_help = /** @type {(inputs: Audio_Description_Export_Automix_Attack_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapidez com que o mecanismo de abaixamento (ducking) é aplicado (ms) quando a VO começa.`)
};

/**
* | output |
* | --- |
* | "How quickly ducking is applied (ms) when VO starts" |
*
* @param {Audio_Description_Export_Automix_Attack_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_attack_help = /** @type {((inputs?: Audio_Description_Export_Automix_Attack_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Attack_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_attack_help(inputs)
	if (locale === "de") return de_audio_description_export_automix_attack_help(inputs)
	if (locale === "it") return it_audio_description_export_automix_attack_help(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_attack_help(inputs)
	if (locale === "es") return es_audio_description_export_automix_attack_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_attack_help(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_attack_help(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_attack_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_attack_help(inputs)
	return en_audio_description_export_automix_attack_help(inputs)
});